export enum Category {
  'apps' = 'apps',
  'websites' = 'websites',
  'design' = 'design',
}
